
import FilterSliderInput from "~/components/filters/FilterSliderInput.vue";

export default {
  name: "FilterSliderComponent",

  props: {
    valueMinimal: {
      type: Number,
      default: 0
    },
    valueMaximal: {
      type: Number,
      default: 0
    },

    optionMinimal: {
      type: Number,
      default: 0
    },
    optionMaximal: {
      type: Number,
      default: 0
    },

    step: {
      type: Number,
      default: () => {
        return 1
      }
    },
    fixedSymbols: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  components: {
    FilterSliderInput,
  },
  data: function () {
    let _valueMin = Number.parseFloat(this.valueMinimal || '0');
    if (_valueMin < this.optionMinimal) {
      _valueMin = this.optionMinimal;
    }

    let _valueMax = Number.parseFloat(this.valueMaximal || '100');
    if (_valueMax > this.optionMaximal) {
      _valueMax = this.optionMaximal;
    }

    return {
      valueMin: _valueMin || '0',
      valueMax: _valueMax || '100',

      isShowRangeSlider: false,

      timeoutSliderSlideEnd: null
    }
  },
  emits: [
    'change'
  ],
  watch: {
    valueMinimal: function () {
      this.valueMin = this.valueMinimal;
    },
    valueMaximal: function () {
      this.valueMax = this.valueMaximal;
    },
  },
  computed: {
    isEmptyValues: function () {
      const isEmptyMin = Boolean(String(this.valueMin) === String(this.optionMinimal));
      const isEmptyMax = Boolean(String(this.valueMax) === String(this.optionMaximal));
      return Boolean(isEmptyMin &&  isEmptyMax)
    }
  },
  methods: {
    submitValue: function (values) {
      let valueMin = values?.[0];
      let valueMax = values?.[1];

      if (+valueMin < +this.optionMinimal) {
        valueMin = this.optionMinimal;
      }
      if (+valueMax > +this.optionMaximal) {
        valueMax = this.optionMaximal;
      }

      if (String(valueMin) === String(this.optionMinimal)) {
        valueMin = "";
      }
      if (String(valueMax) === String(this.optionMaximal)) {
        valueMax = "";
      }

      if (String(valueMin) === String(this.valueMinimal) && String(valueMax) === String(this.valueMaximal)) {
        return
      }
      this.$emit("change", {
        range: [valueMin, valueMax]
      })
    },

    sliderDragEnd: function (event) {
      this.submitValue([
        event?.currentValue?.[0],
        event?.currentValue?.[1],
      ]);
    },
    sliderSlideEnd: function (values) {
      clearTimeout(this.timeoutSliderSlideEnd);

      const valueMin = String(values?.[0].toFixed(this.fixedSymbols) || this.valueMinimal);
      const valueMax = String(values?.[1].toFixed(this.fixedSymbols) || this.valueMaximal);
      this.valueMin = valueMin;
      this.valueMax = valueMax;

      this.timeoutSliderSlideEnd = setTimeout(() => {
        this.submitValue([
          valueMin,
          valueMax
        ]);
      }, 500);
    },
    changeInputValue: function (event, type) {
      let valueMin = this.valueMin;
      let valueMax = this.valueMax;

      if (type === "min") {
        valueMin = event;
      }
      if (type === "max") {
        valueMax = event;
      }

      this.submitValue([valueMin, valueMax]);
    },
  }
}
